var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import "../../epics/index.js";
import { loadExperimentationGroupsEpicReducer, loadAssignmentUnitsEpicReducer, loadRootExperimentationGroupEpicReducer, loadAnalysisRuleEpicReducer, editAnalysisRuleEpicReducer, loadAnalysisTemplatesEpicReducer, CLEAR_ANALYSIS_RULE_EDIT_ACTION, analysisRulePrefix } from "./Edit.epics.js";
const defaultReducerState = {
  experimentationGroups: getDefaultAsyncWrapperObj(),
  assignmentUnits: getDefaultAsyncWrapperObj(),
  rootExperimentationGroup: getDefaultAsyncWrapperObj(),
  analysisRule: getDefaultAsyncWrapperObj(),
  editAnalysisRule: getDefaultAsyncWrapperObj(),
  analysisTemplates: getDefaultAsyncWrapperObj()
};
const reducer = (state = defaultReducerState, action) => {
  state = loadExperimentationGroupsEpicReducer.reduxChange(state, action);
  state = loadAssignmentUnitsEpicReducer.reduxChange(state, action);
  state = loadRootExperimentationGroupEpicReducer.reduxChange(state, action);
  state = loadAnalysisRuleEpicReducer.reduxChange(state, action);
  state = editAnalysisRuleEpicReducer.reduxChange(state, action);
  state = loadAnalysisTemplatesEpicReducer.reduxChange(state, action);
  switch (action.type) {
    case analysisRulePrefix + "/LOADED":
    case CLEAR_ANALYSIS_RULE_EDIT_ACTION:
      return __spreadProps(__spreadValues({}, state), {
        editAnalysisRule: getDefaultAsyncWrapperObj()
      });
    default:
      return state;
  }
};
export {
  reducer as default,
  defaultReducerState,
  reducer
};
//# sourceMappingURL=Edit.ducks.js.map
